const INDUSTRY_ANALYSIS_METERING_HOOK = "IndustryAnalysisMetering";
export const MARKET_ANALYSIS_HOOK = "MarketAnalysis";
const HELP_TOOLTIP_WIDTH = 230;
const SIGNALS_HELP_ARTICLE_LINK =
    "https://similar.slack.com/archives/C053ER5CEP7/p1712823441986129?thread_ts=1712759927.410899&cid=C053ER5CEP7";
